import { render, staticRenderFns } from "./CustomName.vue?vue&type=template&id=ef2dbf42&"
import script from "./CustomName.vue?vue&type=script&lang=js&"
export * from "./CustomName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports